import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  InputCostEstimationDialogContext,
  InputCostEstimationDialogInitialState,
} from "./";

export const InputCostEstimationDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    InputCostEstimationDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <InputCostEstimationDialogContext.Provider value={context}>
      {children}
    </InputCostEstimationDialogContext.Provider>
  );
};
